module.exports = __webpack_public_path__ + "static/media/ic_photo_black_24px.a73b9cc8.svg";